const videoMixin = {
  methods: {
    /*
     * 点击上传视频图标
     * */
    onShowVideoEditor() {
      this.dialogVideoVisible = true
      this.showUploadLoading = false
    },
    /*
     *确认上传格式
     * */
    beforeUploadVideo(file) {
      const videoTypeList = [
        'video/mp4',
        'video/ogg',
        'video/flv',
        'video/avi',
        'video/wmv',
        'video/rmvb',
      ]
      const isVideoType = videoTypeList.indexOf(file.type) === -1
      if (isVideoType) {
        this.$message({
          type: 'error',
          message: '请上传正确视频的格式',
        })
        return false
      }
    },
    /*
     * 移除视频文件的回调
     * */
    onRemoveVideo(file) {
      for (const [index, item] of this.localVideoList.entries()) {
        if (file.name === item.name) {
          this.localVideoList.splice(index, 1)
          return
        }
      }
    },
    /*
     * 上传视频文件
     *@parma option {object} 上传参数
     * */
    async onUploadVideo(option) {
      const { file } = option
      await this.getUserDocFolderIDByType(file.name)
      const data = new FormData()
      data.append('fileName', file.name) // 文件名称
      data.append('currentNode', this.folderId) // 当前目录的id
      data.append('File', file)
      this.showUploadLoading = true
      const { success, data: result } = await this.$http({
        data,
        url: this.$api.uploadFile,
        method: 'post',
        noCancelToken: true,
      })
      if (success) {
        for (let i = 0; i < this.localVideoList.length; i++) {
          if (this.localVideoList[i].name === file.name) {
            this.localVideoList[i].fileId = result.documentVersionID
            await this.getVideoUrl(result.documentVersionID, i)
          }
        }
      }
    },
    // 视频文件发生改变时的回调
    onChangeVideo(file) {
      if (!this.localVideoList.some(video => video.name === file.name)) {
        this.localVideoList.push(file)
      }
    },
    /*
     * 保存视频文件
     * */
    onSaveVideo() {
      const videoList = this.localVideoList
      for (let i = 0; i < videoList.length; i++) {
        const divDom = document.createElement('div')
        const videoDom = document.createElement('video')
        divDom.style.border = '1px solid #f5f5f5'
        divDom.className = 'area__container'
        divDom.style.height = 'auto'
        divDom.style.width = 'calc(100% - 2em)'
        divDom.style.margin = '1em'
        videoDom.className = 'qrcode_video'
        videoDom.style.width = '100%'
        videoDom.style.height = '100%'
        videoDom.style.objectFit = 'fill'
        videoDom.src = videoList[i].url
        videoDom.setAttribute('controls', 'controls')
        divDom.appendChild(videoDom)
        this.beforeInsertElement(divDom)
      }
      this.dialogVideoVisible = false
    },
    /*
     * 兼容浏览器,根据file文件转化成url
     * @parma file {file} 文件
     * @return {string} url
     * */
    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        url = window.createObjectURL(file)
      } else if (window.URL !== undefined) {
        url = window.URL.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        url = window.webkitURL.createObjectURL(file)
      }
      return url
    },
    /*
     * 获取储存文件夹folderId
     * @parma fileName {string} 文件名
     * */
    async getUserDocFolderIDByType() {
      const { success, data } = await this.$http({
        url: this.$api.getUserDocFolderIDByType,
        params: {
          entityID: this.getQrcodeId(),
          folderType: 'NormalUpload',
        },
        noCancelToken: true,
      })
      if (success) {
        this.folderId = data
      }
    },
    /*
     * 获取视频文件地址
     * @parma ID {number} 文件ID
     * @parma index {number} 索引
     * */
    async getVideoUrl(ID, index) {
      const { success, data } = await this.$http({
        url: `${this.$api.getPreviewUrl}?docVersionID=${ID}&engine=${'DKViewer'}`,
      })
      if (success) {
        const { Url } = data
        const videoUrl = `${WEB_CONFIG.BASE_URL}/${Url}`
        this.localVideoList[index].url = videoUrl
        this.showUploadLoading = false
      }
    },
    /*
     * 上传进度条
     * */
    uploadVideoProcess() {},
  },
}

export default videoMixin
